/** Aligné sur useCampaignComments — fenêtre Analyse max. */
export const ANALYSIS_COMMENTS_MAX_DAYS = 90;

export const formatCampaignTitleCase = (text) => {
  if (!text) {
    return "";
  }

  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const startOfLocalDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

/** Jours calendaires consécutifs de la fenêtre Analyse (start → min(stop, now), max 90 j). */
export const getCampaignAnalysisDayList = (campaignPeriod) => {
  if (!campaignPeriod?.start) {
    return [];
  }

  const campaignStart = startOfLocalDay(campaignPeriod.start);
  const campaignStop = new Date(campaignPeriod.stop || campaignPeriod.start);
  const now = startOfLocalDay(new Date());
  let end = startOfLocalDay(
    new Date(Math.min(campaignStop.getTime(), now.getTime())),
  );

  if (end < campaignStart) {
    return [];
  }

  let start = campaignStart;
  const maxSpanMs = ANALYSIS_COMMENTS_MAX_DAYS * 24 * 60 * 60 * 1000;
  if (end.getTime() - start.getTime() > maxSpanMs) {
    start = startOfLocalDay(new Date(end.getTime() - maxSpanMs));
  }

  const days = [];
  const cursor = new Date(start);
  while (cursor.getTime() <= end.getTime()) {
    days.push(new Date(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return days;
};

/** Aligné sur MONGO_ALERTS_START backend — taux fiable à partir de cette date. */
const TREATMENT_RATE_AVAILABLE_FROM = new Date("2026-05-16T00:00:00.000Z");

export const isTreatmentRateAvailable = (stop) => {
  if (!stop) return false;
  const stopDate = new Date(stop);
  if (Number.isNaN(stopDate.getTime())) return false;
  return stopDate >= TREATMENT_RATE_AVAILABLE_FROM;
};

export const formatCampaignDateRangeBadge = (start, stop, locale) => {
  if (!start || !stop) return "";

  const format = (date) =>
    new Date(date).toLocaleDateString(locale || "fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  return `${format(start)} au ${format(stop)}`;
};
